<style scoped>
.gallery {
    display: grid; 
    grid-template-columns: repeat(4, 1fr); 
    gap: 20px;
    padding: 20px 0;
}

.image-card {
    flex-basis: 300px;
    flex-grow: 1;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    position: relative;
    overflow: visible; /* Importante para que el dropdown no se corte */
}

.image-card img {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.image-card p {
    padding: 10px;
    margin: 0;
    font-size: 0.9em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.copy-btn {
    position: absolute;
    top: 5px;
    right: 5px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.copy-btn:hover {
    background: #f0f0f0;
}

.copy-btn {
    padding: 10px;
    font-size: 16px;
}

.copy-btn .fa {
    font-size: 1.2em;
    color: #4A5568; 
    transition: color 0.2s ease;
}

.copy-btn:hover .fa {
    color: #3182CE; 
}

</style>

<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('images')" :directory="$t('list')" :icon="'image'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addImage = true"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_image') }}
                        </button>
                    </div>
                </div>
                <div class="col-12">
                    <div col-md-4 col-sm-12 v-if="images.length > 0" class="gallery">
                        <div 
                            v-for="image in images" 
                            :key="image.id" 
                            class="image-card"
                            @click.stop=""
                        >
                    <button 
                        @click.stop="copyToClipboard(image.url)"
                        class="copy-btn"
                        title="Copiar URL"
                    >
                        <i class="fa fa-copy"></i>
                    </button>

                    <img :src="image.url" :alt="image.file_name">
                    <p>{{ image.file_name }}</p>
                </div>
                    </div>
                    <p v-else>No images uploaded.</p>
                </div>
            </div>
        </div>
        <AddImage 
            v-if="addImage"
            @close="addImage = false"
            @image-uploaded="handleResponse"
        />
    </div>
</template>

<script>

import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import AddImage from './AddImage.vue';
import { getMediaList } from "./api/api";

export default {
    extends: CoreLibrary,
    mixins: [FormMixin],
    components :{
        AddImage
    },  
    data() {
        return {
            addImage : false,
            images : [],
            activeImageId: null,
        }
    },
    async mounted(){
        const response = await getMediaList(); 
        this.images = response.data.data;
        document.addEventListener('click', this.closeOptions);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeOptions);
    },
    methods : {
       handleResponse() {
            this.addImage = false;
            location.reload();
        },
        copyToClipboard(url) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url)
                    .then(() => {
                        this.$toastr.s(`URL copied: ${url}`);
                    })
                    .catch(err => {
                        console.warn("Clipboard API falló, usando fallback:", err);
                        this.copyFallback(url);
                    });

            } else {
                this.copyFallback(url);
            }
        },
        copyFallback(text) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed";
            textarea.style.opacity = "0";
            textarea.style.left = "-9999px";
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                const success = document.execCommand("copy");
                if (success) {
                    this.$toastr.s(`URL copied: ${text}`);
                } else {
                    this.$toastr.e(`The URL could not be copied`);
                }
            } catch (err) {
                console.error("Fallback error:", err);
                this.$toastr.e(`The URL could not be copied`);
            }
            document.body.removeChild(textarea);
        }
    },
    
}
    
</script>

